module.exports = __webpack_public_path__ + "img/risk3.8a932fcc.png";